module.exports = __webpack_public_path__ + "static/media/Artboard4.2bb8b038.png";